// The URL a server render answers for (ADR-027 points 3 and 5): Node has no
// `window`, so a render sets this once before it starts and reads it back
// through this module, from the router for the path it matches and from
// `active-language.ts` for the language a "/es/" prefix names. Cleared once
// the render ends, so a stray read outside one answers the default path.

let path: string | undefined;

/** Sets the URL path the current server render answers for; `undefined` clears it. */
export function setServerPath(value: string | undefined): void {
  path = value;
}

/** The path set for this render, or "/" when none is set (a stray call outside one). */
export function serverPath(): string {
  return path ?? "/";
}
